import { duplicateTasks as _duplicateTasks } from '@griply/services';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  writeBatch,
} from 'firebase/firestore';
import { Task } from 'shared/types/task';

import { getAuthentication, getDatabase } from './helpers';

export const duplicateTasks = async (tasks: Task[]) => {
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  return _duplicateTasks({
    tasks,
    userId: user.uid,
    collection,
    doc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch: (db) => writeBatch(db as Firestore),
  });
};
